import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";

const Word = ({ progress, range, word }) => {
  const opacity = useTransform(progress, range, [0.12, 1]);
  return (
    <motion.span style={{ opacity }} className="inline-block">
      {word}
      {"\u00A0"}
    </motion.span>
  );
};

export const ScrubText = ({ text, className = "" }) => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start 0.9", "end 0.45"] });
  const words = String(text).split(" ").filter(Boolean);
  return (
    <p ref={ref} className={`relative ${className}`}>
      {words.map((w, i) => (
        <Word key={i} progress={scrollYProgress} range={[i / words.length, Math.min(1, (i + 1.5) / words.length)]} word={w} />
      ))}
    </p>
  );
};
